export class ProductRestrictionFunctions {
    constructor(item) {
        let button = document.querySelector('[data-restriction-button]');
        let content = document.querySelector('[data-restriction-content]');
        let hideText = button.dataset.hidealltext;
        let showText = button.dataset.showalltext;

        if(content){
            button.addEventListener('click', () => {
                if(button.classList.contains('closed')){
                    // open
                    content.classList.remove('closed');
                    button.classList.remove('closed');
                    content.classList.add('opened');
                    button.classList.add('opened');
                    button.innerHTML = hideText;
                } else {
                    // close
                    content.classList.remove('opened');
                    button.classList.remove('opened');
                    content.classList.add('closed');
                    button.classList.add('closed');
                    button.innerHTML = showText;
                }
            });
        }
    }
}

document.querySelectorAll('.c-product__restrictions[data-accordion-active="true"]').forEach((item) => {
    new ProductRestrictionFunctions(item);
});
